import apis from "../../apis";

export const login = async (email, password) => {
  try {
    const response = await apis.post("/login", {
      emailOrPhone: email,
      password: password,
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};